import { isNil } from 'lodash';

export const isDefined = <T>(v: T | null | undefined): v is T => !isNil(v);
